export default __webpack_public_path__ + "static/media/warning-icon.34c98c1a.svg";